import { render, staticRenderFns } from "./DataDiscoveryViewModal.vue?vue&type=template&id=2b3f05d7&"
import script from "./DataDiscoveryViewModal.vue?vue&type=script&lang=js&"
export * from "./DataDiscoveryViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports